export default "__VITE_ASSET__CvmHSzCM__"